module.exports = __webpack_public_path__ + "img/1559614606.631aa3a8.jpg";